import ImmunizationMMRView from "./ImmunizationMMRView";

export default ImmunizationMMRView;
